import { render, staticRenderFns } from "./csv_upload.vue?vue&type=template&id=bd8cd4ce&"
import script from "./csv_upload.vue?vue&type=script&lang=js&"
export * from "./csv_upload.vue?vue&type=script&lang=js&"
import style0 from "./csv_upload.vue?vue&type=style&index=0&id=bd8cd4ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports